module.exports = __webpack_public_path__ + "portal/assets/img/logo.881f4cf1.svg";